var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3639 1.21065C13.0028 0.929784 12.4972 0.929784 12.1361 1.21065L3.13606 8.21065C2.89247 8.4001 2.75 8.69141 2.75 9V20C2.75 20.7957 3.06607 21.5587 3.62868 22.1213C4.19129 22.6839 4.95435 23 5.75 23H19.75C20.5457 23 21.3087 22.6839 21.8713 22.1213C22.4339 21.5587 22.75 20.7957 22.75 20V9C22.75 8.69141 22.6075 8.4001 22.3639 8.21065L13.3639 1.21065ZM16.75 21H19.75C20.0152 21 20.2696 20.8946 20.4571 20.7071C20.6446 20.5196 20.75 20.2652 20.75 20V9.48908L12.75 3.26686L4.75 9.48908V20C4.75 20.2652 4.85536 20.5196 5.04289 20.7071C5.23043 20.8946 5.48478 21 5.75 21H8.75V12C8.75 11.4477 9.19772 11 9.75 11H15.75C16.3023 11 16.75 11.4477 16.75 12V21ZM10.75 21V13H14.75V21H10.75Z",
    fill: "#A2A1AB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome1);
export default __webpack_public_path__ + "static/media/home_1.eaedd66e3080c15ad0e37aa49a083977.svg";
export { ForwardRef as ReactComponent };